/**
 * 英文语言包
 */
export default {
  appName: "PowerCoin",
  home_title: "Home",

  //#region 主题
  theme: {
    light: "Light",
    dark: "Dark",
  },
  //#endregion

  //#region 错误提示
  error: {
    emailError: "Invalid email format!",
  },
  //#endregion

  //#region 路由

  route: {
    home: "Home",
    hangqing: {
      title: "Market",
      tabs: {
        zfb: "Gainers",
        dfb: "Losers",
      },
      tabs_item: {
        jyd: "Trading Pair",
        zxj: "Latest Price",
        zd: "Low",
        zg: "High",
        zf24h: "24H Change",
        cjl: "Volume",
      },
    },
    contract: {
      title: "Contracts",
      yue: "Balance",
      yjzsr: "Estimated Total Income",
      fxl: "Risk Rate",
      ytj: "Submitted!",
    },
    options: {
      title: "Futures",
    },
    transaction: {
      title: "Spot",
      yue: "Balance",
      yjzsr: "Estimated Total Income",
      fxl: "Risk Rate",
      ytj: "Submitted!",
    },
    me: {
      title: "Mine",
      zzc: "Total Assets",
      chongzhi: "Deposit",
      tixian: "Withdraw",
      zhuanzhang: "Transfer",
      tuichu: "Logout",
      unlogin_desc: "Are you sure you want to log out?",
      ytcdl: "Logged out",

      menus: {
        daikuan: "Loan",
        daikuan_desc: "One-stop loan service entrance",
        zichan: "Assets",
        zichan_desc: "View account holdings and total assets",
        lishi: "History",
        lishi_desc: "View all your transaction records",
        zjls: "Fund Flow",
        zjls_desc: "View all your fund transactions",
        kf: "Customer Service",
        kf_desc: "Contact platform support",
        txmm: "Withdraw Password",
        txmm_desc: "Set your withdraw password",
        ptjj: "Platform Overview",
        ptjj_desc: "Learn about the platform background and core advantages",
        czmm: "Reset Password",
        czmm_desc: "Change login password to secure your account",
        kyc: "KYC Certification",
        kyc_desc: "Complete identity verification to unlock more features",
        tcdl: "Log Out",
      },
    },
    about: {
      title: "About",
    },
    recharge: {
      title: "Deposit",
      save_qr: "Save QR Code",
      copy_address: "Copy Address",
      cbsl: "Deposit Amount",
      yjdz: "Estimated Arrival",
      llx: "Chain Type",
      wu: "None",
      ndzzhx: "Your Transfer Hash",
      tijiao: "Submit",
      qsr_cbsl: "Please enter deposit amount",
      qsrzz_hash: "Please enter transfer hash",
      czsq_ytj: "Deposit request submitted!",
      copy_success: "Copied successfully",
      copy_error: "Copy failed!",
      notfind_qr: "QR code not found",
    },
    transfer: {
      title: "Transfer",
      zzsl: "Transfer Amount",
      all: "All",
      keyong: "Available",
      zy_zichan: "Transfer Assets",
      wallet: "Wallet",
      contract_wallet: "Contracts Wallet",
      option_wallet: "Futures Wallet",
      xianhuo_wallet: "Spot Wallet",
      zy_success: "Transfer successful",
    },
    withdraw: {
      title: "Withdraw",
      tibi: "Withdraw",
      to_szhb_address: "Crypto Address",
      select_bz: "Select Coin",
      qkl_network: "Blockchain Network",
      address: "Address",
      shuliang: "Amount",
      all: "All",
      keyong: "Available",
      kdzsl: "Amount Receivable",
      txfy: "Withdrawal Fee",
      sxf: "Fee",
      tx: "Withdraw",
      set_txmm: "Set Withdraw Password",
      txysq: "Withdrawal Requested",
    },
    transaction_record: {
      title: "Transaction Records",
    },
    lever_record: {
      title: "Leverage Records",
    },
    myassets: {
      title: "My Assets",
      zzc: "Total Assets",
      hyye: "Futures Balance",
      qqye: "Contracts Balance",
      xhye: "Spot Balance",
      qbye: "Wallet Balance",
    },
    fund_flowing_water: {
      title: "Fund Flow",
      tabs: {
        chongzhi: "Recharge",
        tixian: "Withdrawal",
      },
      cz: {
        danhao: "Order Number",
        zffs: "Payment Method",
        czlx: "Recharge Type",
        bz: "Currency",
        czsl: "Recharge Amount",
        sjjz: "Actual Value",
        ysjg: "Original Price",
        dj: "Unit Price",
        ddzt: "Order Status",
        czdz: "Recharge Address",
        czhash: "Recharge Hash",
        wcsj: "Completion Time",
        cjsj: "Creation Time",
      },
      tx: {
        txdh: "Withdrawal Order Number",
        txje: "Withdrawal Amount",
        sxf: "Service Fee",
        sjdzje: "Actual Received Amount",
        zt: "Status",
        shbz: "Review Remarks",
        shsj: "Review Time",
        dksj: "Payment Time",
        cjsj: "Creation Time",
      },
      recharge_method: {
        on_chain: "On-chain Recharge",
        bank_transfer: "Bank Transfer",
        wechat: "WeChat Pay",
        alipay: "Alipay",
        offline: "Offline Payment",
        admin_manual: "Manual Top-up (Admin)",
        third_party_sdk: "Third-party SDK Payment",
        internal_balance: "Internal Balance Transfer",
        gift: "Gift Recharge",
      },
      order_status: {
        pending: "Pending Payment",
        paid: "Paid (Pending Processing)",
        processing: "Processing",
        completed: "Completed",
        cancelled: "Cancelled",
        failed: "Payment Failed",
        refunded: "Refunded",
      },
      withdraw_status: {
        pending: "Pending Review",
        approved: "Approved",
        paid: "Paid",
        rejected: "Rejected",
        cancelled: "Cancelled",
      },
    },
    kyc: {
      title: "Real Name Verification",
      sjmc: "Full Name",
      qsrzsmc: "Please enter your real name",
      sjhm: "Phone Number",
      qsrsjh: "Please enter your phone number",

      jszz_sfz: "Driver's License / ID Card",
      qsr_jszz_sfz: "Please enter your driver's license / ID card",
      zmz: "Front Photo",
      bmz: "Back Photo",
      zt: "Status:",
      qr: "Confirm",
      wsh: "Not Reviewed",
      yjj: "Rejected",
      ytt: "Approved",
      qsczjzmz: "Please upload the front side of your ID",
      qsczjfmz: "Please upload the back side of your ID",
      tjcg: "Submitted successfully",
    },
    loans: {
      title: "Loan",
      ndzsed: "Your Exclusive Credit Limit",
      qsrdkje: "Please enter the loan amount",
      fw: "Range",
      jyzq: "Borrowing Period",
      rll: "Daily Interest Rate",
      lx: "Interest",
      hkfs: "Repayment Method",
      dkjg: "Lending Institution",
      submit: "Submit"
    },
    kline: {
      title: "K-Line",
      mairu: "Buy",
      maichu: "Sell",
    },
  },
  components: {
    LoginComponent: {
      phone: "Please enter your mobile phone number",
      emailorphone: "Please Enter Email",
      login: "Login",
      register: "Register",
      wjmm: "Forgot Password?",
      qsrmm: "Please Enter Password",
      dzyj: "Please Enter Email",
      email_code: "EMAIL Verification Code",
      fasong: "Send",
      dlmm: "Login Password",
      yqm:"Invitation Code",
      ljzc: "Register Now",
      yyzh: "Already Have an Account?",
      qudenglu: "Go to Login",
      qrmm: "Confirm Password",
      queren: "Confirm",
      sjhbnwk: "Mobile Number Cannot Be Empty",
      mmbnwk: "Password Cannot Be Empty",
      qsryx: "Please Enter Email!",
      yzmyfs: "Verification Code Sent!",
      zccg: "Registration Successful!",
      czmmcg: "Password Reset Successful!",
    },
    HeaderComponent: {
      home: "Home",
      heyue: "Contracts",
      qiquan: "Futures",
      xianhuo: "Spot",
      wode: "Mine",
      ptjj: "Platform Overview",
      dingyue: "Subscribe",
      about: "About",
    },
    HomeComponent: {
      controller: {
        danjia: "Unit Price",
        zdsl: "Max Quantity",
        meiyuan: "USD",
        qxztzcp: "Please select an investment product",
        qxzgg: "Please select leverage",
        ljtz: "Invest Now",
        quxiao: "Cancel",
      },
      contents: {
        jiage: "Price",
        lirun: "Profit",
        mrzdxdl: "Max daily order quantity",
        ljtz: "Invest Now",

        t1: "Data-driven. AI-Powered. Quantified control.",
        t2: "Smarter investments start here.",
        t3: "Integrating strategy, data, and AI to deliver actionable quantitative solutions for modern markets.",
        t4: "Explore AI-driven quantitative investment plans",
        t5: "Why Choose Us",
        t6: "Safety and Compliance",
      },
      xzlist: {
        t1: "Comprehensive Risk Control Integration",
        t1_desc: "Risks are measured, modeled, and managed.",
        t2: "Real-time Market Analysis",
        t2_desc: "Stay ahead with data-driven real-time decisions.",
        t3: "AI-Powered Quant Strategies",
        t3_desc: "Cutting-edge AI supports every investment decision.",
        t4: "Financial Expert Support",
        t4_desc: "Built by experienced quantitative and AI professionals.",
        t5: "Stable Return Potential",
        t5_desc:
          "Designed to achieve reliable returns in all market conditions.",
        t6: "Global Diversified Assets",
        t6_desc: "Spread your risk across multiple global markets.",
      },
      aqhglist: {
        t1: "Regulated and Licensed Trading Platform",
        t2: "All trades secured with bank-grade encryption",
        t3: "Instant withdrawals and full transparency",
      },
    },
    BottomComponent: {
      menus: {
        hangqing: "Market",
        heyue: "Contracts",
        qiquan: "Futures",
        xianhuo: "Spot",
        wode: "Mine",
      },
    },
    EmptyComponent: {
      empty_data: "Empty Data",
    },
    AIOrderTaskWindow: {
      title: "AI Orders",
      rwd: "Task Sheet",
      cp: "Product",
      gmfy: "Purchase Cost",
      zsy: "Total Earnings",
      rws: "Number of Tasks",
      yxsj: "Running Time",
      startTime: "Start Time",
      overTime: "End Time",
      active: "Running",
      pending: "Pending",
      finish: "Completed",
    },
    OrderTaskWindow: {
      tabs: {
        heyue: "Futures",
        qiquan: "Contracts",
        xianhuo: "Spot",
      },
      item: {
        buy: "Buy",
        sell: "Sell",
        shou: "Lot",
        kaipanjia: "Open Price",
        zhiyingjia: "Take Profit",
        zhisunjia: "Stop Loss",
        shouxufei: "Fee",
        baozhengjin: "Margin",
        sunyi: "P/L",
        zhuangtai: "Status",
        jiesuanzhuangtai: "Settlement Status",
        lrssl: "Profit/Loss Ratio",
        kfsj: "Open Time",
        gbsj: "Close Time",
        pcj: "Close Price",
        zhang: "Up",
        die: "Down",
        fangxiang: "Direction",
        sxlx: "Validity Type",
        sxx: "Validity",
        ccsj: "Position Open Time",
        bcsj: "Position Close Time",
        tzje: "Investment Amount",
        rcjg: "Entry Price",
        pcjg: "Close Price",
        ykje: "Profit/Loss Amount",
        czfs: "Operation Type",
        cjsj: "Creation Time",
        cje: "Transaction Amount",
        mmsl: "Trade Quantity",
        cjze: "Total Transaction",
        sxf: "Fee",
        xdsj: "Order Time",
        chengjiaosj: "Execution Time",
        xdly: "Order Source",
      },
    },
    CurrencyListComponent: {
      yx: "Perpetual",
      hy: "Futures",
      mc: "Name",
      zxjg_24hzd: "Latest Price/24H Change",
    },
    ContractCenterConsoleComponent: {
      buy: "Buy",
      sell: "Sell",
      jyfs: "Trading Method",
      ganggan: "Leverage",
      dqzyjg: "Current Best Price",
      gdje: "Limit Price",
      scjg: "Market Price",
      jysl: "Trade Quantity",
      gdjg: "Limit Price",
      ky: "Available",
      kjy: "Tradable",
      shou: "Lot",
      bzj: "Margin",
      xdcg: "Order Placed!",
      mrdt: "Buy (Long)",
      mczk: "Sell (Short)",
    },
    RealTimePriceCompnent: {
      jg: "Price",
      sl: "Quantity",
    },
    ContractHoldingPositionComponent: {
      zhisun: "Stop Loss",
      zyjg: "Take Profit Price",
      qsrzyjg: "Enter Take Profit Price",
      zsjg: "Stop Loss Price",
      qsrzsjg: "Enter Stop Loss Price",
      quxiao: "Cancel",
      queding: "Confirm",
      jiaoyi: "Trade",
      weituo: "Order",
      yiguanbi: "Closed",
      yichexiao: "Cancelled",
      buy: "Buy",
      sell: "Sell",
      shou: "Lot",
      kaipanjia: "Open Price",
      zhiyingjia: "Take Profit",
      zhisunjia: "Stop Loss",
      baozhengjin: "Margin",
      sunyi: "P/L",
      shouxufei: "Fee",
      kaipanshijian: "Open Time",
      lirunsunshilv: "Profit/Loss Ratio",
      setzs: "Set Stop Loss",
      dangqianjiage: "Current Price",
      pingcang: "Close Position",
      quxiaodingdan: "Cancel Order",
      kaifangshijian: "Open Time",
    },
    KLineComponent: {
      "24hzgj": "24H High",
      "24hcjl": "24H Volume",
      "24hzdj": "24H Low",
      "24hcje": "24H Turnover",
      time: "Time:",
      open: "Open:",
      high: "High:",
      low: "Low:",
      close: "Close:",
      volume: "Volume:",
      change: "Change:",
      turnover: "Turnover:",
    },
    RecentTransactionsComponent: {
      zjjy: "Recent Transactions",
      jiage: "Price",
      shuliang: "Quantity",
    },
    OrderListComponent: {
      title: "My Orders",
      fuhao: "Symbol",
      touzijuece: "Investment Decision",
      zhixingjiage: "Execution Price",
      jiesuanjiage: "Settlement Price",
      chengjiaoriqi: "Transaction Date",
      shouru: "Income",
      jiesuanriqi: "Settlement Date",
    },
    OptionsCenterConsoleComponent: {
      jyjg: "Trade Result",
      cjrq: "Transaction Date",
      jsrq: "Settlement Date",
      zxjg: "Execution Price",
      jsj: "Settlement Price",
      tz: "Investment",
      sr: "Income",
      queding: "Confirm",
      qx: "Cancel",
      tzjc: "Investment Decision",
      lr: "Profit",
      konggu: "Holdings",
      history: "History",
      close: "Close",
      daoqi: "Expired",
      hqsjsb: "Failed to fetch data!",
      tzjebxdy0: "Investment amount must be greater than 0!",
      cpsjyc: "Product data error!",
      cjqqcg: "Contracts created successfully!",
    },
    TransactionCenterConsoleComponent: {
      buy: "Buy",
      sell: "Sell",
      jyfs: "Trading Method",
      gdje: "Limit Price",
      dqzyhjg: "Current Best Price",
      jysl: "Trade Quantity",
      jyl: "Trade Volume",
      mrdt: "Buy (Long)",
      mczk: "Sell (Short)",
      scjg: "Market Price",
      gdjg: "Limit Price",
    },
    TransactionRecordComponent: {
      zs: "Stop Loss",
      zyjg: "Take Profit Price",
      qsrzyjg: "Enter Take Profit Price",
      zsjg: "Stop Loss Price",
      qsrzsjg: "Enter Stop Loss Price",
      quxiao: "Cancel",
      queren: "Confirm",
      jiaoyi: "Trade",
      weituo: "Order",
      yiguanbi: "Closed",
      yichexiao: "Cancelled",
      buy: "Buy",
      sell: "Sell",
      shou: "Lot",
      kaipanjia: "Open Price",
      zhiyingjia: "Take Profit",
      zhisunjia: "Stop Loss",
      baozhengjin: "Margin",
      sunyi: "P/L",
      shouxufei: "Fee",
      kaipanshijian: "Open Time",
      lirunsunshilv: "Profit/Loss Ratio",
      setzs: "Set Stop Loss",
      dangqianjiage: "Current Price",
      pingcang: "Close Position",
      quxiaodingdan: "Cancel Order",
    },
    WithdrawPwdComponent: {
      txmmsz: "Set Withdraw Password",
      oldpwd: "Old Password",
      newpwd: "New Password",
      querenpwd: "Confirm Password",
      qsrjmm: "Enter old password",
      qsrxmm: "Enter new password",
      qsrqrmm: "Confirm new password",
      save: "Save",
    },
    ResetPasswordComponent: {
      email: "Email",
      mail_code: "Email Code",
      fasong: "Send",
      dlmm: "Login Password",
      qrmm: "Confirm Password",
      qrcz: "Confirm Reset",
      quxiao: "Cancel",
      qsr_email: "Please enter email!",
      yzmyfs: "Verification code sent!",
      czmmcg: "Password reset successfully!",
    },
  },

  //#endregion
};
